import React, { useContext, useRef, useState } from "react";
import UserPanelHeader from "../components/UserPanelHeader";
import Footer from "../components/Footer";
import { AuthContext } from "../context/auth";
import SuccessAlert from "../admin/components/SuccessAlert";
import ErrorAlert from "../admin/components/ErrorAlert";

export default function UserProfile() {
  const showHide = useRef(null);

  const showHandler = () => {
    showHide.current.type = "text";
  };

  const HideHandler = () => {
    showHide.current.type = "password";
  };

  const { authorizeUserData, setAuthorizeUserData } = useContext(AuthContext);

  // State handling
  const [usersData, setUsersData] = useState({
    user_img: "",
    user_first_name: "",
    user_last_name: "",
    user_email: "",
    user_password: "",
    user_home_address: "",
    user_phone_number: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(true);
  const [updateLoading, setUpdateLoading] = useState(false);

  if (loading && authorizeUserData) {
    setUsersData(authorizeUserData);
    setLoading(false);
  }

  // Upload Image Handling
  const userImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setUsersData({
          ...usersData,
          user_img: imgReader.result,
        });
        setAuthorizeUserData({
          ...authorizeUserData,
          user_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  // Form Submission To Update User Profile Data In DataBase
  const updateUsersHandler = async (e) => {
    window.scrollTo(0, 0);
    setUpdateLoading(true);

    try {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/edit-user/${usersData.user_email}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(usersData),
        }
      );
      const result = await response.json();

      if (response.ok) {
        setError("");
        setSuccess("Profile Updated!");
        setAuthorizeUserData(result);
      } else if (!response.ok) {
        setSuccess("");
        setError("Update Failed! Please Try Again");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setUpdateLoading(false);
    }
  };

  if (updateLoading)
    return (
      <div class="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div class="spinner-grow" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>Updating Profile</p>
      </div>
    );

  if (!updateLoading)
    return (
      <>
        {/* Showing Alert based on http request response Start */}
        <div className="container-fluid p-0">
          <div className="row app-container mt-3">
            {success && <SuccessAlert successMsg={success} />}
            {error && <ErrorAlert errorMsg={error} />}
          </div>
        </div>
        {/* Showing Alert based on http request response End */}

        {/* User Panel Header Start */}
        <UserPanelHeader
          userName={usersData.user_first_name}
          userEmail={usersData.user_email}
          userImg={usersData.user_img}
          userImgHandler={userImgHandler}
        />
        {/* User Panel Header End */}

        {/* User Account Section Start */}
        <div className="container-fluid p-0">
          <div className="row app-container signup-form-cover update-form-cover">
            <form
              method="post"
              className="p-0"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="d-flex gap-3 signup-form-row">
                <div className="col p-0 signup-col">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    name="user_first_name"
                    placeholder="First Name"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_first_name}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_first_name: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    name="user_last_name"
                    placeholder="Last Name"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_last_name}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_last_name: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
              </div>

              <div className="d-flex gap-3 signup-form-row">
                <div className="col p-0 signup-col">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Email"
                    className="form-control"
                    required
                    value={usersData.user_email}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_email: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    name="user_password"
                    placeholder="Password"
                    className="form-control"
                    ref={showHide}
                    required
                    value={usersData.user_password}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_password: e.target.value.toLowerCase(),
                      });
                    }}
                    onFocus={showHandler}
                    onBlur={HideHandler}
                  />
                </div>
              </div>

              <div className="d-flex gap-3 signup-form-row">
                <div className="col p-0 signup-col">
                  <label className="form-label">Home Address</label>
                  <input
                    type="text"
                    name="user_home_address"
                    placeholder="Home Address"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_home_address}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_home_address: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="text"
                    name="user_phone_number"
                    placeholder="Mobile Number"
                    className="form-control"
                    required
                    value={usersData.user_phone_number}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_phone_number: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
                onClick={updateUsersHandler}
              >
                Update Account
              </button>
            </form>
          </div>
        </div>
        {/* User Account Section End */}

        {/* Footer Start */}
        <Footer />
        {/* Footer End */}
      </>
    );
}